module.exports = __webpack_public_path__ + "static/media/tea.38bc90fc.svg";